import importerSelectors from '../../../modules/shared/importer/importerSelectors'

const followersImporterSelectors = importerSelectors(
  'followers.importer',
)

export default followersImporterSelectors
